import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';

interface ISimpleDialog {
    title: string;
    onCancel: Function;
    onOk: Function;
    open: boolean;
    children?: any;
    okButtonForm?: string;
    hideCancel?: boolean;
}

function SimpleDialog(props: ISimpleDialog) {
    const { children, hideCancel = false, okButtonForm, onCancel, onOk, open, title, ...other } = props;

    const handleCancel = () => {
        onCancel();
    };

    const handleOk = () => {
        onOk();
    };

    return (
        <Dialog
            aria-labelledby="confirmation-dialog-title"
            data-cy="SimpleDialog"
            disableBackdropClick
            disableEscapeKeyDown
            fullWidth={true}
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
            <DialogContent dividers>{children}</DialogContent>
            <DialogActions>
                {!hideCancel && (
                    <Button color="primary" onClick={handleCancel}>
                        Cancel
                    </Button>
                )}
                <Button
                    color="primary"
                    form={okButtonForm ? okButtonForm : ''}
                    onClick={handleOk}
                    type={okButtonForm ? 'submit' : 'button'}
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SimpleDialog;
